import classNames from 'classnames';
import React, { FC } from 'react';

interface IProps {
  isVisible: boolean;
  backdropTop?: boolean;
  isBlack?: boolean;
}
const BackDrop: FC<IProps> = ({ isVisible, backdropTop = false, isBlack }): JSX.Element | null => {
  return isVisible
    ? <div
      className={classNames('backdrop', {
        'backdrop-black': isBlack,
        'backdrop-top': backdropTop
      })}
      >
    </div>
    : null;
};

export default BackDrop;
